// Header styles
//    - @author Naroa Gonzalez <naroa@hp.com>
//    - @date March 3rd 2023
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.

import styled from 'styled-components';
import { xsMax } from '@veneer/tokens/dist/tokens/tokens';
import '@veneer/styles/typography/typography.css';
const headerHeight = '66px';
const footerHeight = '78px';

// Container for the Home
export const HomeContainer = styled.div`
  width: 100%;
  height: calc(100vh - ${headerHeight} - ${footerHeight});
  display: flex;
  align-items: center;
  min-width: ${xsMax};
  background-color: #035c84;
  background-size: cover;
  background-position: center right;
`;
